// Session-topic sanitiser, shared by the web (LobbyContext sanitises untrusted
// wire input; TopicSelector caps typing) and the backend (POST /api/queue/next
// sanitises the topic it forwards in a VoIP push). One definition so a topic
// is normalised identically no matter which path it travels.
/** Hard cap on a topic string. Anything longer would wreck the guide's chip row
 *  and the OS notification body. */
export const TOPIC_MAX_LENGTH = 60;
// Covers C0/C1 controls, plus zero-width characters (U+200B-U+200D,
// U+2060) and bidirectional-override/embedding characters (U+202A-U+202E,
// U+2066-U+2069) -- none of those are whitespace as far as JS \s is
// concerned, so left unstripped they can render an invisible or reversed
// topic on the one line a guide reads before accepting a call.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001F\u007F-\u009F\u200B-\u200D\u2060\u202A-\u202E\u2066-\u2069]/g;
/** Normalise a topic from ANY source — the learner's own typing, or an invite
 *  published by an untrusted lobby peer. Returns undefined for anything that
 *  isn't a usable string, so callers can treat "no topic" uniformly. */
export function sanitizeTopic(value) {
    if (typeof value !== 'string')
        return undefined;
    const cleaned = value
        .replace(CONTROL_CHARS, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, TOPIC_MAX_LENGTH)
        // .slice() cuts by UTF-16 code unit, so it can land between the two
        // halves of a surrogate pair (e.g. an emoji at the boundary). Drop a
        // dangling high surrogate rather than let it render as a replacement
        // glyph.
        .replace(/[\uD800-\uDBFF]$/, '')
        .trim(); // slice can leave a trailing space
    return cleaned.length > 0 ? cleaned : undefined;
}
